<template>
  <Modal @close="close">
    <div slot="modal-header">
      <span>{{ $t('general.add_to_cart') }}</span>
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center text-center">
      <label>
        <b>{{ $t('general.amount') }}</b>
      </label>
      <div class="d-flex justify-content-center align-items-center text-center">
        <el-button class="left-button" @click="minusCount">
          <i class="el-icon-minus" />
        </el-button>
        <input v-model="count" disabled class="middle-input" />
        <el-button class="right-button" @click="plusCount">
          <i class="el-icon-plus" />
        </el-button>
      </div>
      <label class="text-center mt-3">
        <b>{{ $t('general.total_weight') }}</b><br />
        <span class=" px-3 text-center">{{ weight }} KG</span>
      </label>
    </div>
    <div slot="modal-footer">
      <el-button @click="addTo">
        {{ $t('general.add') }}
      </el-button>
    </div>
  </Modal>
</template>

<script>
import Modal from '../atoms/Modal';
import { mapActions, mapGetters } from 'vuex';
import StoreModules from '../../store/store-modules';
export default {
  name: 'AddProductModal',
  components: { Modal },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {},
  destroyed() {},
  data() {
    return {
      count: 1,
    };
  },
  computed: {
    weight() {
      return this.count * this.product.get('containerSize').split(' ')[0];
    },
  },
  methods: {
    ...mapActions(StoreModules.CART, ['addToCart']),
    close() {
      this.$emit('close');
    },
    addTo() {
      let item = {
        modxId: this.product.get('modxId'),
        objectId: this.product.id,
        name: this.product.get('name'),
        count: this.count,
      };
      this.addToCart({ type: 'products', items: [item] }).then(() => {
        this.close();
        this.$message.info(this.$t('messages.added_item_success'));
      });
    },
    minusCount() {
      if (this.count > 1) this.count--;
    },
    plusCount() {
      this.count++;
    },
  },
};
</script>

<style lang="scss" scoped>
.left-button {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-right: 0;
  &:focus {
    outline: 0;
  }
}
.right-button {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-left: 0;
  &:focus {
    outline: 0;
  }
}

.middle-input {
  text-align: center;
  height: 40px;
  border-radius: 0;
  border: 1px solid #e3e3e3;
  width: 70px;
}
</style>
